import { Component } from '@angular/core';

@Component({
    selector: 'app-update-michelin-stock',
    templateUrl: './update-michelin-stock.component.html',
    standalone: false
})
export class UpdateMichelinStockComponent {
  selectedFile: any;

  selectFile(event: any) {
    this.selectedFile = event.target.files;
    console.log(typeof this.selectedFile);
  }
}
